/**
 * Error codes shared by the mock data layer and the API (apps/api/src/http/errors.ts).
 * Forms show VALIDATION / DATE_TAKEN / CONFLICT inline; everything else becomes a toast.
 */
export type ApiErrorCode =
  | "AUTH"
  | "VALIDATION"
  | "FORBIDDEN"
  | "NOT_FOUND"
  | "DATE_TAKEN"
  | "CONFLICT"
  | "STALE"
  | "RATE_LIMIT"
  | "SERVER"
  | "NETWORK";

export class ApiError extends Error {
  constructor(
    public code: ApiErrorCode,
    message: string,
    public fields?: Record<string, string>,
    public meta?: Record<string, unknown>,
  ) {
    super(message);
    this.name = "ApiError";
  }
}
